import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import { G2S } from 'core/g2s';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
import OrderOpinionComponent from 'src/components/order/opinion';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component({
    components: {
        'v-order-opinion': OrderOpinionComponent
    }
})
export default class FlightsBookingConfirmationComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    reservationInfo: api.ReservationInfo;

    @Prop()
    currentUser: api.UserWithBonuses;

    gaParams: utils.GoogleAnalyticsParams = new utils.GoogleAnalyticsParams();

    cancelProductRequestsInProgress = {};
    cancelProductId: number = 0;
    cancelProductIndex: number = 0;

    modalProductInfo = {
        buttonText1: 'Оставить услугу со скидкой 50%',
        text:  `<div>
                <div class="d-flex flex-row">
                    <h2>Как жаль, что вы отказываетесь от услуги <span>умный пакет</span></h2>
                </div>
                <div class="text mt-2 pl-0">
                    <p>Мы расстроены и дарим вам 50% скидки на заказ данной услуги</p>
                </div>
                </div>`
    };

    selectedProduct: api.Product | any = {
        adapter: '',
        id: 0,
        kitId: 0,
        name: '',
        description: '',
        cancelPossible: false,
        productReservationId: 0,
        type: '',
        status: ''
    }

    disabledModalButton: boolean = false;

    get orderLabel(): string {
        return i18next.t('label_order_your_with_number', <any>{ i: this.reservationInfo.reservationNumber });
    }

    get orderUrl(): string {
        return '/order/' + this.reservationInfo.reservationPublicId;
    }
    productDiscount(pId){
        if(this.reservation.couponProduct == pId) {
            console.log(pId);
            return this.reservation.couponDiscountAmount
        } else {
            return null;
        }
    }

    get orderPaymentUrl(): string {
        return '/order/payment/' + this.reservationInfo.reservationPublicId;
    }

    get thankYouTitle(): string {
        if (this.currentUser && this.currentUser.firstName) {
            return i18next.t('title_thank_you_named', <any>{ i: this.currentUser.firstName });
        } else {
            return i18next.t('title_thank_you');
        }
    }

    get thankYouDetails(): string {
        const d = this.reservation.selectedFlight!.legs[0].departureDestination.city.localizedName
            + ' — ' + this.reservation.selectedFlight!.legs[0].arrivalDestination.city.localizedName;

        return i18next.t('label_flight_booking_confirmation_details_full', <any>{ i: d });
    }

    detailProduct(index: number) {
        this.cancelProductId = this.reservationInfo!.products[index].productReservationId;
        this.cancelProductIndex = index;
        this.selectedProduct = this.reservationInfo!.products[index];

        (<any>this).$ga.sendEvent('order.view', 'product.detail', `order.view.product.detail${this.selectedProduct.saleType ? '.' + this.selectedProduct.saleType : ''}${this.selectedProduct.kitId ? '.kit' + this.selectedProduct.kitId : ''}.id${this.selectedProduct.id}`.toLowerCase(), this.gaParams);
        (<any>this.$refs).modalProduct.isActive = true; 
    }

    cancelProduct(index: number) {
        const productReservationId = this.reservationInfo.products[index].productReservationId;
        const billingPrice = this.reservationInfo.products[index].billingPrice;
        const request: api.CancelProductRequest = {
            productReservationId
        };

        this.$set(this.cancelProductRequestsInProgress, `${productReservationId}`, true);
        new api.ReservationService().cancelProduct(request).then(
            (result: api.CancelProductResponse) => {
                if(this.reservationInfo!.products[index].id == this.reservation.couponProductId){
                    this.reservation.couponDiscountAmount = 0;
                    this.reservationInfo.couponDiscountAmount = 0;
                    this.reservation.couponProduct.selected = false;
                }
                (<any>this.$refs).modalProduct.isActive = false;
                this.$set(this.cancelProductRequestsInProgress, `${productReservationId}`, false);
                (<any>this).$ga.sendEvent('order.view', 'product.detail', `order.view.product.detail${this.selectedProduct!.saleType ? '.' + this.selectedProduct!.saleType : ''}.btn.cancel${this.selectedProduct!.kitId ? '.kit' + this.selectedProduct!.kitId : ''}.id${this.selectedProduct.id}`.toLowerCase(),this.gaParams);
                if (result.popup) {
                    this.modalProductInfo.buttonText1 = result.popup.buttonText1;
                    this.modalProductInfo.text = result.popup.text;
                    (<any>this.$refs).modalProductDetails.isActive = true;
                    (<any>this).$ga.sendEvent('order.view', 'msg.hold', `order.view.msg.hold${this.selectedProduct!.saleType ? '.' + this.selectedProduct!.saleType : ''}${this.selectedProduct!.kitId ? '.kit' + this.selectedProduct!.kitId : ''}.id${this.selectedProduct!.id}`.toLowerCase(),this.gaParams);
                } else {
                    // eslint-disable-next-line no-cond-assign
                    const productPackageRules = utils.cancelProductWithPackage[this.selectedProduct.externalId];

                    if (productPackageRules) {
                        const deleteProducts = this.reservationInfo.products.reduce((arr, product, index) => {
                            if (productPackageRules.includes(product.externalId)) {
                                arr.push(index);
                            }
                            return arr;
                        }, <number[]>[]);
                        
                        deleteProducts.reverse().forEach((indexProd) => {
                            this.$delete(this.reservationInfo.products, indexProd);
                            this.$delete(this.reservation!.products, indexProd);
                        });
                    }

                    this.$delete(this.reservationInfo.products, index);
                    this.$delete(this.reservation!.products, index);
                    this.reservationInfo.amount = this.reservationInfo.amount - billingPrice;
                    (<any>this.$root).$refs.dialogMessage.show({
                        title: '',
                        text: result.localizedMessage
                    });
                }
            },
            (error) => {
                this.$set(this.cancelProductRequestsInProgress, `${productReservationId}`, false);
                (<any>this.$root).$refs.dialogMessage.show({
                    title: i18next.t('error'),
                    text: (error.response.data && error.response.data.message) ? error.response.data.message : i18next.t('error_server_tryagain')
                });
            }
        );
    }

    cancelProductAfterPopup(applyDiscount: boolean) {
        const productReservationId = this.cancelProductId;
        const billingPrice = this.reservationInfo!.products[this.cancelProductIndex].billingPrice;
        const index = this.cancelProductIndex;
        const productId = this.reservationInfo!.products[index].id;

        const request: api.CancelProductAfterPopupRequest = {
            applyDiscount,
            productReservationId
        };
        if (!this.disabledModalButton) {
            this.disabledModalButton = true;
            new api.ReservationService().cancelProductAfterPopup(request).then(
                (result: any) => {
                    (<any>this.$refs).modalProductDetails.isActive = false;
                    this.disabledModalButton = false;
                    this.$set(this.cancelProductRequestsInProgress, `${productReservationId}`, false);

                    if (result.product) {
                        (<any>this).$ga.sendEvent('order.view', 'msg.hold', `order.view.msg.hold${this.selectedProduct!.saleType ? '.' + this.selectedProduct!.saleType : ''}.btn.discount${this.selectedProduct!.kitId ? '.kit' + this.selectedProduct!.kitId : ''}.id${productId}`.toLowerCase(),this.gaParams);
                        this.reservationInfo!.products[index].price = result.product.price;
                        this.reservationInfo!.products[index].billingPrice = result.product.billingPrice;
                        (<any>this.$root).$refs.dialogMessage.show({
                            title: '',
                            text: result.localizedMessage
                        });
                    } else {
                        (<any>this).$ga.sendEvent('order.view', 'msg.hold', `order.view.msg.hold${this.selectedProduct!.saleType ? '.' + this.selectedProduct!.saleType : ''}.btn.discount${this.selectedProduct!.kitId ? '.kit' + this.selectedProduct!.kitId : ''}.id${productId}`.toLowerCase(),this.gaParams);
                        this.$delete(this.reservationInfo!.products, index);
                        this.$delete(this.reservation!.products, index);
                        this.reservationInfo!.amount = this.reservationInfo!.amount - billingPrice;
                        (<any>this.$root).$refs.dialogMessage.show({
                            title: '',
                            text: result.localizedMessage
                        });
                    }
                },
                (error) => {
                    this.disabledModalButton = false;
                    (<any>this.$root).$refs.dialogMessage.show({
                        title: i18next.t('error'),
                        text: (error.response.data && error.response.data.message) ? error.response.data.message : i18next.t('error_server_tryagain')
                    });
                }
            );
        }
    }

    getBookingClassLabel(bookingClass: string): string {
        return i18next.t('label_flight_class_' + bookingClass.toLowerCase());
    }

    getGenderIcon(passenger: api.PassengerInfo): string {
        return passenger.gender.toLowerCase();
    }

    getSupportLink(value) {
        return `/support/new/${this.reservationInfo!.reservationNumber}?t=${value}&email=${this.reservationInfo!.contactEmail}`;
    }

    supportEvent() {
        (<any>this).$ga.sendEvent('support.new', 'click', 'support.new.click');
        (<any>this).$ga.reachGoal('support.new.click');
        (<any>this).$ga.reachGoal('support.new.click.order');
    }

    onFlightDetails() {
        this.$emit('details');
    }
}
